export { LocalStorageServiceSingleton as default };

/**
* Local Storage Service, handles data from local storage,
*
* When local storage is disabled, saves all keys in memory
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class LocalStorageService {
  /**
   * Constructor
   *
   * @since 7.0.0
   */
  constructor() {
    this.storage = null;

    try {
      window.localStorage.setItem('StorageCheck', true);
      window.localStorage.removeItem('StorageCheck');
      this.storage = window.localStorage;
    } catch (e) {
      this.storage = {};
    }
  }

  /**
   * Sets an item in the Session Storage
   *
   * @since 7.0.0
   *
   * @param {string} key  data key
   * @param {mixed}  data data to be storage
   *
   * @return {void}
   */
  setItem(key, data) {
    this.storage[key] = data;
  }

  /**
   * Retrieves an item from the Session Storage
   *
   * @since 7.0.0
   *
   * @param {string} key           data key
   * @param {mixed}  default_value retieves
   *
   * @return {void}
   */
  getItem(key, default_value = null) {
    return this.storage[key] || default_value;
  }


  /**
   * Stringifys an object and saves it to storage
   *
   * @since 7.0.0
   *
   * @param {string} key  data key
   * @param {mixed}  data data to be storage
   *
   * @return {void}
   */
  setObject(key, data) {
    this.storage[key] = JSON.stringify(data);
  }

  /**
   * Retrieves an objcet from the Session Storage
   *
   * @since 7.0.0
   *
   * @param {string} key           data key
   * @param {mixed}  default_value retieves
   *
   * @return {void}
   */
  getObject(key, default_value = null) {
    return (this.storage[key])
      ? JSON.parse(this.storage[key])
      : default_value;
  }

  /**
   * Removes an item from Session Storage
   *
   * @since 7.0.0
   *
   * @param {string} key  data key
   * @param {mixed}  data data to be storage
   *
   * @return {void}
   */
  removeItem(key) {
    delete this.storage[key];
  }
}

const LocalStorageServiceSingleton = new LocalStorageService();